var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnderwriting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.58319 11.5504L3.04569 5.21875L7.625 1L12.197 5.21875L10.6597 11.5504H4.58319ZM5.46875 10.4254H9.77413L10.9466 5.60238L8.1875 3.05238V5.48706C8.35287 5.58806 8.48556 5.72144 8.58556 5.88719C8.68556 6.05306 8.73556 6.23888 8.73556 6.44463C8.73556 6.7495 8.62669 7.01081 8.40894 7.22856C8.19106 7.44631 7.92975 7.55519 7.625 7.55519C7.31537 7.55519 7.05169 7.44631 6.83394 7.22856C6.61619 7.01081 6.50731 6.7495 6.50731 6.44463C6.50731 6.23888 6.55731 6.05188 6.65731 5.88363C6.75731 5.71538 6.89237 5.58319 7.0625 5.48706V3.05238L4.30344 5.60238L5.46875 10.4254ZM2 15.25L2.38363 14.1466C2.474 13.8773 2.63125 13.6622 2.85537 13.5012C3.07937 13.3402 3.33225 13.2597 3.614 13.2597H11.636C11.9177 13.2597 12.1706 13.3402 12.3946 13.5012C12.6187 13.6622 12.776 13.8773 12.8664 14.1466L13.25 15.25H2Z",
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderwriting);
export default __webpack_public_path__ + "static/media/Underwriting.def411e05fbdb4b3b7dab092dc6fb29f.svg";
export { ForwardRef as ReactComponent };